import React, { useState } from "react";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import LogoutSessionsSlideOver from "../../../modal/LogoutSessionsSlideOver";

const AdminSecurity = ({ isMobile }) => {
  const sessions = [
    {
      title: "New York, USA",
      label: "iPhone 14 Pro Max",
      date: "09/09/2023",
      icon: EllipsisVerticalIcon,
    },
    {
      title: "New York, USA",
      label: "iPhone 14 Pro Max",
      date: "09/09/2023",
      icon: EllipsisVerticalIcon,
    },
    {
      title: "New York, USA",
      label: "iPhone 14 Pro Max",
      date: "09/09/2023",
      icon: EllipsisVerticalIcon,
    },
    {
      title: "New York, USA",
      label: "iPhone 14 Pro Max",
      date: "09/09/2023",
      icon: EllipsisVerticalIcon,
    },
    {
      title: "New York, USA",
      label: "iPhone 14 Pro Max",
      date: "09/09/2023",
      icon: EllipsisVerticalIcon,
    },
  ];
  const [showSlide, setShowSlide] = useState(false);

  return (
    <div>
      {!isMobile && (
        <h4 className="text-xl md:text-[22px] font-bold leading-[160%] text-customGray mb-5 md:mb-[35px]">
          Active Sessions
        </h4>
      )}
      <div className="relative">
        <div className="absolute z-[10] left-0 top-0 w-full h-full bg-[rgba(0,0,0,0.5)] pointer-events-none flex items-center justify-center">
          <h2 className="text-3xl font-bold text-white text-center">
            Coming Soon
          </h2>
        </div>
        <ul>
          {sessions.map((session) => (
            <li className="flex justify-between items-start gap-5 border border-solid border-[#EBEFF3] px-5 py-[11px] rounded-md bg-white mb-[14px]">
              <div>
                <h6 className="text-base font-bold leading-[160%] text-customGray mb-1">
                  {session.title}
                </h6>
                <p className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[14px]">
                  <span>{session.label}</span> &#8226;{" "}
                  <span>{session.date}</span>
                </p>
              </div>
              <div>
                <session.icon className="w-6 h-6 text-[#485868]" />
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="text-right mt-[30px]">
        <Link
          className="text-sm font-bold leading-[160%] capitalize text-primary pointer-events-none"
          onClick={() => setShowSlide(true)}
        >
          Log out of all sessions
        </Link>
      </div>
      <LogoutSessionsSlideOver show={showSlide} setShowSlide={setShowSlide} />
    </div>
  );
};

export default AdminSecurity;
